import { render } from "./PressCard.vue?vue&type=template&id=7ed51c25&scoped=true"
import script from "./PressCard.vue?vue&type=script&lang=js"
export * from "./PressCard.vue?vue&type=script&lang=js"

import "./PressCard.vue?vue&type=style&index=0&id=7ed51c25&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed51c25"]])

export default __exports__